import { render, staticRenderFns } from "./KanbanHeader.vue?vue&type=template&id=31756ae1&"
import script from "./KanbanHeader.vue?vue&type=script&lang=js&"
export * from "./KanbanHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports